// Reine Helfer für die Rechnungs-Zuständigkeit (Mitarbeiter ODER Team).
// Der Anzeigename wird clientseitig aufgelöst, weil rechnungen.zustaendig_id
// keinen profiles-FK mehr hat (polymorph: profiles.id ODER teams.id) und der
// PostgREST-Embed profiles:zustaendig_id(full_name) darum entfällt.

export type ZustaendigTyp = 'mitarbeiter' | 'team' | null;

export interface ZMember { id: string; full_name: string }
export interface ZTeam { id: string; name: string }

// Löst Anzeigename + Team-Flag für eine Zuständigkeit auf.
// null = Global (keine Zuständigkeit) oder unbekannte id.
// Altbestand: typ NULL wird als Mitarbeiter behandelt.
export const resolveZustaendig = (
  id: string | null | undefined,
  typ: ZustaendigTyp,
  members: ZMember[],
  teams: ZTeam[],
): { name: string; isTeam: boolean } | null => {
  if (!id) return null;
  if (typ === 'team') {
    const t = teams.find((x) => x.id === id);
    return t ? { name: t.name, isTeam: true } : null;
  }
  const m = members.find((x) => x.id === id);
  return m ? { name: m.full_name, isTeam: false } : null;
};

// Anzeige-Label einer Zuständigkeit: aufgelöster Name; sonst 'Unbekannt'
// (id gesetzt, aber nicht auflösbar — z. B. gelöschtes Profil/Team) bzw.
// 'Global' (keine id).
export const zustaendigLabel = (
  id: string | null | undefined,
  typ: ZustaendigTyp,
  members: ZMember[],
  teams: ZTeam[],
): string => {
  const z = resolveZustaendig(id, typ, members, teams);
  if (z) return z.name;
  return id ? 'Unbekannt' : 'Global';
};

// Filter-Prädikat für die Zuständigkeits-Filterleiste.
// filterWert: 'alle' | 'global' | 't:<teamId>' | '<profileId>'
export const matchtZustaendigkeitsFilter = (
  filterWert: string,
  zustaendigId: string | null | undefined,
  zustaendigTyp: ZustaendigTyp,
): boolean => {
  if (filterWert === 'alle') return true;
  if (filterWert === 'global') return zustaendigId == null;
  if (filterWert.startsWith('t:')) {
    return zustaendigTyp === 'team' && zustaendigId === filterWert.slice(2);
  }
  return zustaendigTyp !== 'team' && zustaendigId === filterWert;
};

// Ziel-Person für einen Timeline-Eintrag „Zuweisung".
//
// rechnungen_timeline.ziel_user_id zeigt per Fremdschlüssel auf profiles(id),
// zustaendig_id ist dagegen polymorph (profiles.id ODER teams.id). Eine Team-Id
// dorthin zu schreiben, weist Postgres ab — der Fehler brach beim Speichern die
// ganze Stammdaten-Änderung ab, nachdem die Zuweisung bereits geschrieben war
// (halb gespeicherter Zustand, Ticket Björn 09.09.2026).
//
// Ein Team ist keine Person: dann bleibt das Feld leer. Der Name des Teams steht
// ohnehin im Text des Eintrags. Dieselbe Unterscheidung trifft changeZuweisung
// bereits bei der persönlichen Benachrichtigung.
export const zielUserFuerTimeline = (
  id: string | null | undefined,
  typ: ZustaendigTyp,
): string | null => (typ === 'team' ? null : id || null);
